/**
 * Kinde auth configuration for the admin SPA.
 *
 * These are public, non-sensitive client-side identifiers — safe to hardcode.
 * The actual secrets (API keys, signing keys) live server-side.
 */
export const KINDE_DOMAIN = "https://gamma.kinde.com";
export const KINDE_CLIENT_ID = "cec1b6a9d3d44b50a7b44e7ee62dbf7f";
export const KINDE_ORG_CODE = "org_7d8efc10ab9";
